import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BadgeDirective, TooltipDirective } from '@com-delta-omnichannel/aura';
import { SkyClubTracker } from '../models/skyclub.interfaces';

@Component({
  selector: 'idp-sky-club-tracker',
  standalone: true,
  imports: [CommonModule, BadgeDirective, TooltipDirective],
  templateUrl: './sky-club-tracker.component.html',
  styleUrls: ['./sky-club-tracker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkyClubTrackerComponent {
  @Input() content: SkyClubTracker = {} as SkyClubTracker;
  carouselIndex = 0;

  previous(): void {
    this.carouselIndex--;
  }

  next(): void {
    this.carouselIndex++;
  }
}
